import styles from "./PS5Badge.module.css";
interface PS5BadgeProps {
  badgeClassname?: string;
  innerClassname?: string;
  text: string;
  badgeTitleClassName?: string;
}
const PS5Badge = ({ badgeClassname, innerClassname, text, badgeTitleClassName }: PS5BadgeProps) => {
  return (
    <div className={`${styles.badge} ${badgeClassname}`}>
      <div className={`${styles.inner} ${innerClassname}`}>
        <div className={`${styles.title} ${badgeTitleClassName}`}>
          <img
            src={`${process.env.PUBLIC_URL}/assets/icon/alert.svg`}
            alt="alert"
          />
          <span>{text}</span>
        </div>
        {/* <div className={styles.icon}>
          <img
            src={`${process.env.PUBLIC_URL}/assets/icon/iphone16.png`}
            alt="ps5"
          />
        </div> */}
      </div>
    </div>
  );
};

export default PS5Badge;
